<template>
  <div class="text-setting" :style="{height: collapse ? '46px': '362px'}">
    <div class="text-setting-header" @click="collapse = !collapse">
      <span>文本</span>
      <i class="icon icon-set-down" :style="{transform: collapse ? '' : 'rotate(180deg)'}"></i>
    </div>
    <div class="text-setting-content">
      <div class="font-family-setting"
        :style="{fontFamily: `'${fontFamily.value.split('/').pop()}'`}"
        @mousedown="openPopup($event, 'fontFamily')"
      >
        <span>{{fontFamily.label}}</span>
        <i class="triangle-icon"></i>
      </div>

      <div class="text-size-color">
        <div class="loop-btn">
          <el-input-number
            v-model="fontSize"
            size="mini"
            @change="changeFontSize"
            :min="6"
            :max="1080"
            @focus="togglePreventDefault(false)"
            @blur="togglePreventDefault(true)"
            ref="inputNumber"
          ></el-input-number>
        </div>
        <div class="color-setting"
          :style="{backgroundColor: fontColor}"
          @click="showColorPicker($event, { whichPart: 'font_color' })"
        >
        </div>
        <el-tooltip effect="dark" content="" placement="top">
          <div slot="content" style="font-size: 12px, width: 50px">
            {{!BrandColor ? '品牌配色为团队功能，请创建团队后使用' : ''}}
          </div>
          <el-popover
            popper-class="brand-color-setting"
            placement="bottom"
            width="226"
            trigger="click"
            offset="10"
            :disabled="!BrandColor"
            visible-arrow=""
          >
            <div slot="reference" class="color-team-setting" :class="{'disable': !BrandColor}">
              <i class="icon-set-brand-color"></i>
            </div>
            <div class="set-dropdown-content">
              <div class="dropdown-content-title">
                品牌颜色
              </div>
              <div class="dropdown-content-body">
                <div v-if="BrandColor && BrandColor.length === 0">
                  <p>当前品牌颜色数据为空，</p>
                  <P>请至<a target="_blank" href="/workplace/dashboard/team/brand/colors">工作台品牌管理</a>版块配置</P>
                </div>
                <ul>
                  <li v-for="(item,index) in BrandColor" :key="index">
                    <div class="colorItem"
                      @click="colorPickerInput({hex: item.color}, {type: 'font_color'})"
                      :style="{'background-color':item.color}"
                    ></div>
                  </li>
                </ul>
              </div>
            </div>
          </el-popover>
        </el-tooltip>
      </div>

      <div class="text-setting-art"
        @mousedown="openPopup($event, 'artTextSetting')"
        :class="{'disable': hasVertical}"
      >
        <span>{{'艺术字 - '+artName}}</span>
        <i class="triangle-icon"></i>
      </div>

      <div class="text-setting-style">
        <div
          v-for="v, i in styleArr"
          :key="i"
          :class="{'active': v.active, 'disable': v.disable}"
          :style="v.style"
          @click="setStyle(v, i)"
        >
          <el-tooltip effect="dark" :content="v.tip" placement="top">
            <div>{{v.text}}</div>
          </el-tooltip>
          <span v-if="i < 3"></span>
        </div>
      </div>
      <div class="text-setting-align">
        <div>
          <el-tooltip effect="dark" content="文字方向" placement="top">
            <i class="icon-set-font-mode" @click="switchversionAnyway()" :class="{'disable': hasArt || hasStyle}"></i>
          </el-tooltip>
          <span></span>
        </div>
        <div v-for="v, i in alignArr" :key="i">
          <el-tooltip effect="dark" :content="v.tip" placement="top">
            <i :class="[v.class, v.selected ? 'active': '']"
              :style="{transform: direction === 'Horizontal' ? '' : 'rotate(90deg)'}"
              @click="alignChange(v, i)"
            ></i>
          </el-tooltip>
          <span v-if="i < 2"></span>
        </div>
      </div>
      <div class="text-setting-space">
        <SliderSetting :list="spaceArr" @changeData="spaceChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import textArtStyle from '../mixins/textArtStyle'
import SliderSetting from './sliderSetting.vue'

function composedPath (e = {}) {
 // 存在则直接return
 if (e.path) { return e.path }
 // 不存在则遍历target节点
 let target = e.target
 e.path = []
 while (e.path.length < 2 && target.parentNode !== null) {
  e.path.push(target)
  target = target.parentNode
}
 // 最后补上document和window
 e.path.push(document, window)
 return e.path
}

export default {
  mixins: [textArtStyle],
  props: {
    updateData: {
      type: Number,
      required: true,
      default: 0
    },
    hasVertical: {
      type: Boolean,
      required: true,
      default: false
    },
    hasArt: {
      type: Boolean,
      required: true,
      default: false
    },
    hasStyle: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      collapse: false,
      fontFamily: {
        value: '',
        label: ''
      },
      fontSize: 50,
      fontColor: '#5778fb',
      artName: '无',
      styleArr: [
        {
          text: 'B',
          name: 'fontWeight',
          value: 'bold',
          anti: 'normal',
          active: false,
          disable: false,
          tip: '加粗',
          style: {
            'font-weight': 800,
          }
        }, {
          text: 'I',
          name: 'fontStyle',
          value: 'italic',
          anti: 'normal',
          active: false,
          disable: false,
          tip: '倾斜',
          style: {
            'font-style': 'italic',
            'font-family': 'serif'
          }
        }, {
          text: 'U',
          name: 'textDecoration',
          value: 'underline',
          anti: 'none',
          active: false,
          disable: false,
          tip: '下划线',
          style: {
            'text-decoration': 'underline',
          }
        }, {
          text: 'S',
          name: 'textDecoration',
          value: 'line-through',
          anti: 'none',
          active: false,
          disable: false,
          tip: '删除线',
          style: {
            'text-decoration': 'line-through',
          }
        }
      ],
      direction: 'Horizontal', // Vertical
      alignIndex: 0,
      alignArr: [
        {
          name: 'left',
          selected: false,
          class: 'icon-align-left',
          tip: '左对齐'
        }, {
          name: 'center',
          selected: false,
          class: 'icon-align-center',
          tip: '居中对齐'
        }, {
          name: 'right',
          selected: false,
          class: 'icon-align-right',
          tip: '右对齐'
        }
      ],
      spaceArr: [
        {type: 'lineHeight', name: '行间距', step: 0.1, min: 1, max: 10, len:9, val: 1},
        {type: 'letterSpacing', name: '字间距', step: 1, min: 0, max: 50, len:50, val: 0}
      ],
      showFamily: false,
      showArtList: false,
      undoData: null
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg',
      'SelectScenes_Msg',
      'downFonts',
      'BrandColor'
    ]),
  },
  watch: {
    'updateData'(val, oldVal) {
      this.initData();
    },
  },
  mounted() {
    this.initData();
    this.$bus.on('font', this._font)
    this.$bus.on('btn_panel', this._btn_panel)
    this.$bus.on('artTextSetting', this._artTextSetting)
    this.$bus.on("undoRedoHandle", this._undoRedoHandle);
    this.$bus.on('colorPickerInput.picker', this.colorPickerInput);
    this.$bus.on('fontFamilyClose', this._fontFamilyClose);
    this.$bus.on('artTextClose', this._artTextClose);
  },
  methods: {
    initData() {
      let s = this.SelectSprites_Msg[0];
      let f = s.font;
      this.direction = s.versionAnyway;
      this.fontFamily.value = f.fontFamilyUrl;
      this.fontFamily.label = ((this.downFonts.filter(v => this.fontFamily.value.replace(/"/g, '') === v.value) || [])[0] || {}).label || '';
      this.fontSize = f.fontSize;
      this.fontColor = f.color;
      this.artName = '无'
      for(let i = 0; i < this.styleObject.length; i++) {
        if(this.styleObject[i].val === s.artType) {
          this.artName = this.styleObject[i].name;
          break;
        }
      }
      for(let i = 0; i < this.alignArr.length; i++) {
        this.alignArr[i].selected = false;
        if(this.alignArr[i].name === f.textAlign) {
          this.alignIndex = i;
          this.alignArr[i].selected = true;
        }
      }
      if(this.hasVertical) {
        this.styleArr[1].disable = true;
        this.styleArr[2].disable = true;
        this.styleArr[3].disable = true;
      } else {
        this.styleArr[1].disable = false;
        this.styleArr[2].disable = false;
        this.styleArr[3].disable = false;
      }
      this.styleArr[0].active = f.fontWeight === 'bold';
      this.styleArr[1].active = f.fontStyle === 'italic';
      let de = new Set(f.textDecoration.split(' '));
      this.styleArr[2].active = de.has('underline');
      this.styleArr[3].active = de.has('line-through');

      this.spaceArr[0].val = s.lineHeight;
      this.spaceArr[1].val = s.letterSpacing;
    },
    openPopup(e, name) {
      if(this.showArtList || this.showFamily) {
        this.showArtList = false;
        this.showFamily = false;
        return;
      }
      if(name === 'fontFamily') {
        this.showFamily = true;
        e.stopPropagation()
      } else {
        this.showArtList = true;
        e.stopPropagation()
      }
      composedPath(e);
      let dom = e.path[0].tagName !== "DIV" ? e.path[1] : e.path[0]
      let rect = dom.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue',{
				name : name,
				initialX : rect.left - 35,
        initialY : rect.top + 35,
        posx : rect.left - 1,
        posy : rect.top + 10,
        type : 1,
        from: 'textSetting_Panel',
        sprite: this.SelectSprites_Msg[0],
			});
    },
    changeFontSize() {
      this.updateSprites('fontSize', {font: {fontSize: this.fontSize}}, true)
      this.$bus.emit('panel_btn', {type: 'fontSize', val: this.fontSize})
    },
    setStyle(v, i) {
      if(v.disable) return;
      let data = {};
      let hasStyle = false;
      this.styleArr[i].active = !v.active;
      data[v.name] = v.active ? v.value : v.anti;
      if(v.name === 'textDecoration') {
        if(this.styleArr[2].active || this.styleArr[3].active) {
          data.textDecoration = `${this.styleArr[2].active?this.styleArr[2].value + ' ' : ''}${this.styleArr[3].active?this.styleArr[3].value: ''}`.trim();
        } else {
          data.textDecoration = 'none';
        }
      }
      if(this.styleArr[1].active || this.styleArr[2].active || this.styleArr[3].active) {
        hasStyle = true;
      } else {
        hasStyle = false;
      }
      this.$emit("update:hasStyle", hasStyle);
      this.updateSprites('changeStyle', {font: data}, true)
    },
    alignChange(v, i) {
      if(this.alignIndex === i) return;
      this.alignArr[this.alignIndex].selected = false;
      this.alignArr[i].selected = true;
      this.alignIndex = i;
      this.updateSprites('changeStyle', {font: {textAlign: v.name}}, true)
    },
    spaceChange(val, status, index, item) {
      let data = {};
      let bol = false;
      data[item.type] = val;
      if(status === 'start') {
        this.undoData = {
          scenesId: this.SelectScenes_Msg.id,
          scale: this.TOOL.scale,
          data: {},
          reData: []
        }
        for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
          let s = this.SelectSprites_Msg[i];
          let o = {id: s.id};
          o[item.type] = s[item.type];
          this.undoData.reData.push(o);
        }
      } else if(status === 'end') {
        bol = true;
        this.undoData.data = data;
      }

      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        s.updateSprite(data).then(() => {
          bol && s.effect.init();
        });
      }

      bol && eve("undo_redo", null, {type: 'textSettings', data: this.undoData})
    },
    switchversionAnyway() {
      if(this.hasArt || this.hasStyle) return;
      let data = {versionAnyway: this.direction === 'Horizontal' ? 'Vertical' : 'Horizontal'};
      this.direction = data.versionAnyway;
      if(!this.hasVertical) {
        this.styleArr[1].disable = true;
        this.styleArr[2].disable = true;
        this.styleArr[3].disable = true;
      } else {
        this.styleArr[1].disable = false;
        this.styleArr[2].disable = false;
        this.styleArr[3].disable = false;
      }

      this.$emit("update:hasVertical", !this.hasVertical);
      this.updateSprites('direction', data, true)
    },
    updateSprites(type, data) {
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: $.extend(true, {}, data),
        type: type,
        reData: []
      }

      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        let o = {
          id: s.id,
          versionAnyway:s.versionAnyway,
          font: Object.assign({}, s.font),
          resourceId: s.option.resourceId,
          artType: s.artType,
          lineHeight: s.lineHeight,
          letterSpacing: s.letterSpacing
        }
        undoData.reData.push(o);
        if(type !== 'direction') {
          s.updateSprite(data).then(() => {
            s.effect.init();
          });
        } else {
          s.setversionAnyway(data.versionAnyway)
        }
      }

      eve("undo_redo", null, {type: 'textSettings', data: undoData})
    },
    changeArt(item) {
      let data = {artType: ''};
      let hasArt = false;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: [],
        reData: []
      }
      if(item.val !== 'None') {
        data.artType = item.val;
        this.artName = item.name;
        hasArt = true;
      } else {
        this.artName = '无'
        hasArt = false;
      }
      this.$emit("update:hasArt", hasArt);
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        if(s.artType === item.val) continue;
        data.id = s.id;
        let o = {
          id: s.id,
          artType: s.artType,
          artStyle: Object.assign({}, s.artStyle, { color: s.font.color })
        }
        let special = this.hasSpecialEffect(s.effect.code);

        if(special && item.dynamic) {
          o.effectCode = s.effect.code;
          data.effectCode = 'FadeIn';
          s.updateEffect({code: 'FadeIn'})
        }
        data.artType && (data.artStyle = this.getStyle(item.val, item.color, s.font.fontSize))
        s.artSetting(data)
        undoData.data.push(data);
        undoData.reData.push(o);
      }
      eve("undo_redo", null, {type: 'artSettings', data: undoData})
    },
    showColorPicker(e, { whichPart } = {}) {
      let rect = e.target.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color',
        type: 1,
        posx : rect.left - 150,
        posy : rect.top + 40,
        whichPart,
        color: this.fontColor
      });
    },
    colorPickerInput(obj, { type }) {
      if(type === 'font_color' && obj.hex) {
        this.fontColor = obj.hex;
        this.updateSprites('fontColor', {font: {color: this.fontColor}}, true)
        this.$bus.emit('panel_btn', {type: 'fontColor', val: this.fontColor})
      }
    },
    hasSpecialEffect (code) {
      return /^(?:appear|type|write|bounce|roll)$/i.test('' + code);
    },
    _font (font, from) {
      if(from === 'textSetting_Panel') {
        this.fontFamily.value = font.value;
        this.fontFamily.label = font.label;
        this.updateSprites('fontFamily', {font: {fontFamilyUrl: font.value}, resourceId: font.id}, true)
      }
    },
    _artTextSetting(data) {
      this.changeArt(data)
    },
    _undoRedoHandle({type}) {
      if (type === 'textSettings' || type === 'artSettings') {
        // 异步问题
        setTimeout(() => {
          this.initData();
        }, 100)
      }
    },
    _btn_panel(data) {
      if(data.type === 'fontSize') {
        this.fontSize = data.data;
      } else if (data.type === 'fontColor') {
        this.fontColor = data.data;
      }
    },
    togglePreventDefault(val) {
      // 是否启用快捷键
      this.$store.commit('toggle_isPreventDefault', val);
    },
    _fontFamilyClose(data) {
      this.showFamily = false;
    },
    _artTextClose(data) {
      this.showArtList = false;
    }
  },
  beforeDestroy() {
    this.$bus.off('font', this._font);
    this.$bus.off('artTextSetting', this._artTextSetting);
    this.$bus.off("undoRedoHandle", this._undoRedoHandle);
    this.$bus.off('colorPickerInput.picker', this.colorPickerInput);
    this.$bus.off('btn_panel', this._btn_panel);
    this.$bus.off('fontFamilyClose', this._fontFamilyClose);
    this.$bus.off('artTextClose', this._artTextClose);
  },
  components: {
    SliderSetting
  }
}
</script>

<style lang="scss" scoped>
.text-setting {
  width: 100%;
  transition: all 0.3s;
  border-bottom: 1px solid #D4D4E7;
  overflow: hidden;
}
.text-setting-header {
  display: flex;
  height: 46px;
  line-height: 46px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #474261;
  cursor: pointer;

  i {
    width: 10px;
    height: 6px;
    margin-right: 10px;
    transition: all 0.3s;
  }
}
.font-family-setting, .text-size-color, .text-setting-art, .text-setting-style, .text-setting-align {
  margin-bottom: 15px;
  display: flex;
  justify-content:space-between;
  align-items: center;
  height: 32px;
}
.font-family-setting, .text-setting-art, .text-setting-align {
  border: solid 1px #D9DDEA;
  border-radius: 4px;
  padding-left: 12px;
  padding-right: 12px;

  .triangle-icon {
    display: inline-block;
    width: 10px;
    height: 6px;
    background: url('../../../static/svg/inverted-triangle.svg') no-repeat center;
    &:hover {
      background: url('../../../static/svg/inverted-triangle-active.svg') no-repeat center;
    }
  }
}
.font-family-setting, .text-setting-art{
  cursor: pointer;
}
.loop-btn {
  height: 32px;
}
.color-setting {
  width: 46px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #D9DDEA;
}
.color-team-setting {
  width: 46px;
  height: 32px;
  line-height: 38px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #D9DDEA;

  &.disable {
    opacity: .5;
    cursor: not-allowed;
  }
}
.text-setting-style {
  border: solid 1px #D9DDEA;
  border-radius: 4px;
  padding-left: 4px;
  padding-right: 4px;
  font-size: 19px;

  div {
    cursor: pointer;
    width: 30px;
    height: 16px;
    line-height: 16px;
  }

  span {
    position: relative;
    left: 30px;
    top: -16px;
    height: 16px;
    border-right: 1px solid #D9DDEA;
    cursor: default;
  }

  .active {
    color: #5778FB;
  }
}
.text-setting-align {
  border: solid 1px #D9DDEA;
  border-radius: 4px;
  padding-left: 4px;
  padding-right: 4px;
  font-size: 16px;

  div{
    width: 30px;
    height: 16px;
    line-height: 16px;

    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    i.icon-set-font-mode {
      margin-left: 3px;
    }
  }

  .icon-align-left {
    background: url('../../../static/svg/align-left.svg') no-repeat center;
    &:hover, &.active {
      background: url('../../../static/svg/align-left-active.svg') no-repeat center;
    }
  }
  .icon-align-right {
    background: url('../../../static/svg/align-right.svg') no-repeat center;
    &:hover, &.active {
      background: url('../../../static/svg/align-right-active.svg') no-repeat center;
    }
  }
  .icon-align-center {
    background: url('../../../static/svg/align-center.svg') no-repeat center;
    &:hover, &.active {
      background: url('../../../static/svg/align-center-active.svg') no-repeat center;
    }
  }

  span {
    position: relative;
    display: inline-block;
    left: 20px;
    height: 16px;
    border-right: 1px solid #D9DDEA;
  }
}
.text-setting-space {
  margin-bottom: 15px;
}
.disable {
  opacity: .6;
  cursor: not-allowed !important;
}
.set-dropdown-content {
  position: absolute;
  top: 0;
  left: -5px;
  background: #fff;
  width: 226px;
  // height: 288px;
  border: 1px solid #D9DDEA;
  border-radius: 4px;

  .dropdown-content-title {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border-bottom: 1px solid #D9DDEA;
  }
  .dropdown-content-body {
    margin-top: 10px;
    padding: 0 12px;
    // height: 246px;
    overflow: hidden;

    > div {
      height: 246px;
      padding: 90px 0;
      color: #888;

      p {
        text-align: center;
      }

      a {
        color: #5778FB;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    ul {
      max-height: 246px;
      width: 226px;
      overflow-y: scroll;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      > li {
        margin-right: 6px;
        margin-bottom: 6px;
      }
      > li:nth-child(4n) {
        margin-right: 0;
      }

      .colorItem {
        width: 46px;
        height: 32px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #D9DDEA;
        cursor: pointer;
      }
    }
  }
}
</style>

<style lang="scss">
.loop-btn {

  .el-input-number {
    border: 1px solid #D9DDEA;
    width: 115px;
    height: 32px;
    border-radius: 4px;
    padding: 0;
    overflow: hidden;

    .el-input-number__decrease, .el-input-number__increase {
      width: 32px;
      height: 32px;
      line-height: 32px;
      background: #fff;
      border: none;
      top: 0;

      &:hover {
        background: #EFEFF7;
      }
    }
    .el-input-number__decrease {
      left: 0;
      border-right: 1px solid #D9DDEA;
    }
    .el-input-number__increase {
      right: 0;
      border-left: 1px solid #D9DDEA;
    }
    .el-input .el-input__inner {
      height: 32px;
      border: none;
    }
  }
}
.el-popover.brand-color-setting {
  border: none;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/settingPanel/textSetting.vue